export const checkAssistant = ()=>{
    const item = JSON.parse(localStorage.getItem('user'))?.profile?.logged_in_user;
    return item==='distributor'?false:true;
}